// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3JWlv","rightAdornment":"Header_rightAdornment__2gdpp"};